import React from 'react'
import PropTypes from 'prop-types'
import { Dialog } from 'shared/UI/Dialog'
import Modal from 'react-modal'
import withKeyEventHandler, { KEY_HANDLERS } from 'shared/hocs/withKeyEventHandler'
import PublicEventsDispatcher from 'common/services/PublicEventsDispatcher'
import {
  FormWrapperContainer
} from 'LiveBoard/components/shared/CallToAction/types/forms/ConfigurableForms/CustomForm/Form'
import { CloseButton } from 'shared/UI/CloseButton'

import './style.css.scss'

const MODAL_CLASSES = {
  bodyOpenClassName: "modal-open",
  overlayClassName: "modal-overlay",
  className: "cta-dialog-container",
  portalClassName: "modal cta-modal"
}

const ESC_KEY_CODE = 27
class FormDialog extends React.Component {
  constructor(props) {
    super(props)

    this.publicEventsDispatcher = PublicEventsDispatcher()
  }

  componentDidMount() {
    this.props.provideKeyHandlers({
      [KEY_HANDLERS.esc]: this.handleCloseDialog
    })
  }

  handleCloseDialog = (e) => {
    e && e.stopPropagation()
    this.props.onDone()
    this.props.onCancel && this.props.onCancel()
  }

  render() {
    const {
      config, title, children,
      themeColorHex, submitting,
      submitSucceeded, ctaClass
    } = this.props

    return (
      <Modal isOpen={true} contentLabel="cta" {...MODAL_CLASSES} >
        <Dialog
          className={`cta-form-dialog ${ctaClass}`}
          onClose={this.props.onDone}
          showButtons={false}>
          <div className="cta-form-container" style={{borderColor: themeColorHex}}>
            {(submitting || submitSucceeded) && <span className="form-overlay" /> }
            <CloseButton onClose={this.handleCloseDialog} />
            <FormWrapperContainer
              config={this.props.config}
              area={this.props.area}
              onDone={this.props.onDone}
              onSubmit={this.props.onSubmit}
              customValidation={this.props.customValidation}
              submitBtnLabel={this.props.submitBtnLabel}
              successMessage={this.props.successMessage}
              itemId={this.props.itemId}
              form={this.props.form}
              title={title || config.text}
              initialValues={this.props.initialValues}>
              {children}
            </FormWrapperContainer>
          </div>
        </Dialog>
      </Modal>
    )
  }
}

FormDialog.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  themeColorHex: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  customValidation: PropTypes.func,
  title: PropTypes.string,
  submitBtnLabel: PropTypes.string,
  successMessage: PropTypes.string,
  itemId: PropTypes.number,
  ctaClass: PropTypes.string,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.object
}

FormDialog.defaultProps = {
  ctaClass: ""
}

export default withKeyEventHandler(FormDialog)